import { ActionContextBasic } from '../index'
import { User } from '@/interfaces/user'

export interface State {
  me: User | null;
}

const state = () => ({
  me: null
})

const mutations = {
  SIGN_IN (state: State, me: User) {
    state.me = me
  },
  SIGN_OUT (state: State) {
    state.me = null
  }
}

const actions = {
  signIn: (context: ActionContextBasic, me: User) => {
    context.commit('SIGN_IN', me)
  },
  signOut: (context: ActionContextBasic) => {
    context.commit('SIGN_OUT')
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
